import Vue from "vue";

export const getProducts = ({ dispatch }, ids, fileTypeId, isArchive) => {
  dispatch("LOADING", true);
  Vue.http.get("api/v1/Products", {pageCategoryIds: ids, fileType: fileTypeId, isArchive: isArchive}).then(function (response) {
    dispatch("PRODUCTS_LOADED", response.data);
  }, function (response) {
    dispatch("LOADING_ERROR");
  });
};

export const getProductsByFiletype = ({ dispatch }, fileTypeId, isArchive) => {
  dispatch("LOADING", true);
  Vue.http.get("api/v1/Products", {fileType: fileTypeId, isArchive: isArchive}).then(function (response) {
    dispatch("PRODUCTS_LOADED", response.data);
  }, function (response) {
    dispatch("LOADING_ERROR");
  });
};



// WEBPACK FOOTER //
// ./src/views/products/ProductsActions.js